import { render } from "./PerformanceChart3.vue?vue&type=template&id=c02a4fe4&ts=true"
import script from "./PerformanceChart3.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart3.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__